export type ApiResponse<Data> = {
  message?: string | null;
  data: Data;
};

type DefaultSort = {
  fields: {
    [sortParam: string]: {
      label: string;
      values: Array<string>;
    };
  };
};

export type ApiResponseWithPagination<
  Data,
  Aggregations = undefined,
  Sort = DefaultSort,
  SelectedRootCategories = undefined,
> = {
  message?: string;
  data: {
    /**
     * The current page of data.
     */
    results: Data;

    /**
     * The pagination state.
     */
    pagination: ApiPagination;

    /**
     * Any aggregation data
     */
    aggregations: Aggregations;

    /**
     * Sort options
     */
    sort: Sort;

    /**
     * Selected root categories (for opportunities)
     */
    selectedRootCategories?: SelectedRootCategories;
  };
};

export type ApiV2ResponseWithPagination<Data, Aggregations = undefined> = {
  /**
   * The current page of data.
   */
  data: Data;

  /**
   * The pagination state.
   */
  pagination: ApiPagination;

  /**
   * Any aggregation data
   */
  aggregations: Aggregations;

  /**
   * Sort options
   */
  sort: {
    fields: {
      [sortParam: string]: {
        label: string;
        values: Array<string>;
      };
    };
  };

  /**
   * V2 sort options
   */
  sortOptions: Array<{
    label: string;
    values: Array<string>;
  }>;
};

/**
 * Pagination state returned from the API
 */
export type ApiPagination = {
  count: number;
  prev: number | null;
  next: number | null;
  current: number;
  last: number;
  limit: number;
};

/**
 * Default pagination parameters for a paginated request
 */
export interface ApiPaginatedRequest {
  page?: number;
  limit?: number;
}

export * from './Pagination';
export * from './User';
export * from './misc';
export * from './DiscoverSubmissions';
export * from './Validation';
